import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import InvoiceDetails from "./InvoiceDetails";
import { BASE_URL } from "../../../../config/api";
import { mapInvoiceDetails } from "./InvoicePage";

export default function InvoiceDetailsPage() {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


 useEffect(() => {
  async function loadInvoice() {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(
        `${BASE_URL}zoho/get-invoices-by-id`,
        { params: { invoice_id: invoiceId } }
      );

      // 👇 IMPORTANT PART
      if (res.status === false) {
        setError(res.message || "Something went wrong");
        setInvoice(null);
        return;
      }

      setInvoice(mapInvoiceDetails(res.data.data));
    } catch (e) {
      console.error("Invoice details error", e);
      setError("Failed to load invoice");
      setInvoice(null);
    } finally {
      setLoading(false);
    }
  }

  loadInvoice();
}, [invoiceId]);


if (error) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="rounded-3xl bg-white border border-slate-200 shadow-sm p-6 text-center max-w-sm w-full">
        <div className="text-lg font-extrabold text-slate-900">
          {error}
        </div>

        <button
          onClick={() => navigate("/retinv")}
          className="mt-4 w-full rounded-xl bg-blue-600 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Back to Invoices
        </button>
      </div>
    </div>
  );
}


  if (loading || !invoice) {
  return (
      <div className="min-h-screen flex items-center justify-center text-sm text-slate-600">
      Loading invoice…
      </div>
  );
  }

  return (
    <InvoiceDetails
      invoice={invoice}
      onBack={() => navigate("/invoices")}
      copyLink={(link) => navigator.clipboard.writeText(link)}
    />
  );
}
